<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <!-- หัวข้อ -->
      <!-- <div v-show="almost_mobile" style="margin-top: 15%"></div> -->
      <h3 v-if="type === 'organization'" class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        จัดการข้อมูลองค์กร
      </h3>
      <h3 v-else class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        จัดการข้อมูลสถานประกอบการ
      </h3>
      <div style="margin-top: 30px"></div>
      <v-row class="ml-1">
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn color="#00a99d" outlined dark  @click="addMiniApp()" class="card-small3">
            <span class="pl-2" style="text-transform: capitalize;">Mini App</span>
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn color="#00a99d" dark @click="registerOrganize()" class="card-small">
            <span class="pl-2" style="text-transform: capitalize;">ลงทะเบียน</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="mx-1 my-2 mt-8" style="justify-content: center">
        <!-- แท็บ ข้อมูลองค์กร -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 50%"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet('organization')"
            :class="type === 'organization' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="
                    type === 'organization'
                      ? require('@/assets/icon/building-active.svg')
                      : require('@/assets/icon/building.svg')
                  "
                  class="mr-5 px-3 py-4"
                  :class="type === 'organization' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span :class="type === 'organization' ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>{{ total_organization }}</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span :class="type === 'organization' ? 'text-ffffff' : 'text-00a99d'"
                      >ข้อมูลองค์กร</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- แท็บ ข้อมูลสถานประกอบการ -->
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          style="min-width: 50%"
          class="pt-0 pr-0"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="activeGet('factory')"
            :class="type === 'factory' ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row>
              <v-col cols="12" class="d-flex align-center justify-start pl-6">
                <v-img
                  :src="
                    type === 'factory'
                      ? require('@/assets/icon/building-active.svg')
                      : require('@/assets/icon/building.svg')
                  "
                  class="mr-5 px-3 py-4"
                  :class="type === 'factory' ? 'icon-dark' : 'icon-light'"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span :class="type === 'factory' ? 'text-ffffff' : 'text-00a99d'"
                      ><h3>{{ total_factory }}</h3></span
                    >
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span :class="type === 'factory' ? 'text-ffffff' : 'text-00a99d'"
                      >ข้อมูลสถานประกอบการ</span
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- ค้นหา -->
      <v-row class="mx-1">
        <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="ml-1 mb-3">
          <v-row>
            <v-col cols="12" class="pa-2 card-small">
                <v-text-field v-model="search" class="card-small" @keypress.enter="getOrganizeData()" label="ค้นหาชื่อ เบอร์ และ business id" hint="กรอกคำค้นหา แล้วกด Enter เพื่อค้นหา" dense solo hide-details="auto" append-icon="mdi-magnify" clearable clear-icon="mdi-close-circle"
                @click:clear="(search = ''), getOrganizeData()" color="#00A99D"></v-text-field>
            </v-col>
          </v-row> 
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="12" md="5" lg="4" xl="4" class="card-small mr-1 pa-2 mb-3" v-if="this.type == 'organization'" style="align-self: start;">
          <v-select
            class="card-small"
            v-model="chips_value"
            :items="chips_items"
            item-text="text"
            item-value="value"
            label="ไม่มีบริการ"
            multiple
            solo
            dense
            color="#00A99D"
            hide-details="auto"
            item-color="#00A99D"
            :menu-props="{ bottom: true, offsetY: true }"
            clearable
            clear-icon="mdi-close-circle"
            @input="getOrganizeData()"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0" style="color: #007C92 !important; background-color: #ffffff !important; border: 1px solid !important;">
                <v-avatar left size="100">
                  <img :src="item.text == 'Telemed' ? require('@/assets/icon/telemed.svg') : require('@/assets/icon/Logo_Navbar_Health_Rider_2.png')" />
                </v-avatar>
                <span v-if="item.text == 'Telemed'" class="font-14 text-061B2E w-700">{{ item.text }}</span>
                <span v-else class="font-14 text-061B2E w-700">Health Rider</span>
              </v-chip>
              <v-chip v-if="index === 1" style="color: #00A99D !important; background-color: #ffffff !important; border: 1px solid !important;">
                <v-avatar left size="100">
                  <img :src="item.text == 'Telemed' ? require('@/assets/icon/telemed.svg') : require('@/assets/icon/Logo_Navbar_Health_Rider_2.png')" />
                </v-avatar>
                <span v-if="item.text == 'Telemed'" class="font-14 text-00A99D w-700">{{ item.text }}</span>
                <span v-else class="font-14 text-00A99D w-700">{{ item.text }}</span>
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <!-- ตาราง -->
      <v-row class="mb-3 mx-1">
        <v-col cols="12" class="pt-0">
          <v-data-table
            :headers="type === 'organization' ? headersTable : headersTable1"
            :items="itemTable"
            hide-default-footer
            :loading="loadingTable"
            loading-text="กำลังโหลดข้อมูล"
            class="px-0"
            disable-sort
          >
            <template v-slot:no-data>
              <span class="font-14">ไม่มีข้อมูล</span>
            </template>

            <template v-slot:progress>
              <v-progress-linear
                indeterminate
                height="3px"
                color="#00A99D"
                class="mx-0"
              ></v-progress-linear>
            </template>

            <!-- no -->
            <template v-slot:[`item.no`]="{ index }">
              <div class="d-flex flex-column">
                <span class="font-14 text-061B2E">{{index + 1 + (page - 1) * limit}}</span>
              </div>
            </template>

            <!-- hos_code -->
            <template v-slot:[`item.hos_code`]="{ item }">
              <div class="d-flex flex-column">
                <span class="font-14 text-061B2E">{{ item.hospital_code || "-" }}</span>
              </div>
            </template>

            <!-- biz_id -->
            <template v-slot:[`item.biz_id`]="{ item }">
              <div class="d-flex flex-column">
                <span class="font-14 text-061B2E">{{ item.biz_id || "-" }}</span>
              </div>
            </template>

            <!-- name -->
            <template v-slot:[`item.name`]="{ item }">
              <div class="d-flex flex-column">
                <span class="font-14 text-00A99D">{{ item.first_name_th }}</span>
                <span class="font-14 text-navy-50">วันที่สร้าง : {{ showDate(item.created_at) }}</span>
              </div>
            </template>

            <!-- contact -->
            <template v-slot:[`item.contact`]="{ item }">
              <span class="font-14 text-061B2E">{{ mobile(item.organize_phone) || "-" }}</span>
            </template>

            <!-- address -->
            <template v-slot:[`item.address`]="{ item }">
              <span class="font-14 text-061B2E">{{ item.organize_location || '-' }}</span>
            </template>

            <!-- service -->
            <template v-slot:[`item.service`]="{ item }">
              <div v-if="'service' in item && item.service.length !== 0" style="display: contents;"> 
                <div class="my-3 d-flex flex-column" v-for="(s, index) in item.service" :key="index">
                  <v-chip v-if="s.service == 'telemed'" color="#007C92" outlined class="mx-12 py-3 px-5">
                    <v-avatar left size="100">
                      <img :src="require('@/assets/icon/telemed.svg')" />
                    </v-avatar>
                    <span class="font-14 text-061B2E w-700">{{ s.service[0].toUpperCase() }}{{ s.service.slice(1) }}</span>
                  </v-chip>
                  <v-chip v-if="s.service == 'telepharma'" color="#00A99D" outlined class="mx-12 py-3 px-5">
                    <v-avatar left size="100">
                      <img :src="require('@/assets/icon/Logo_Navbar_Health_Rider_2.png')" />
                    </v-avatar>
                    <span class="font-14 text-061B2E w-700">Health Rider</span>
                  </v-chip>
                </div>
              </div>
              <div v-else style="display: contents;">
                <v-chip color="red" outlined class="mx-12 py-3 px-5">
                  <v-avatar left size="100">
                    <v-icon color="red" size="20">mdi-close-thick</v-icon>
                  </v-avatar>
                  <span class="font-14 text-061B2E w-700">ไม่เปิดให้ใช้บริการ</span>
                </v-chip>
              </div>
            </template>

            <!-- action -->
            <template v-slot:[`item.action`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small outlined v-bind="attrs" v-on="on" class="py-4 px-2 mx-1 image-border"
                    style="max-width: 24px; border: 1px solid #F2F2F2" @click="editOrganize(item)">
                    <v-icon width="28" color="#296ED5">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>แก้ไขข้อมูล</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small outlined v-bind="attrs" v-on="on" class="py-4 px-2 mx-1 image-border"
                    style="max-width: 24px; border: 1px solid #F2F2F2" @click="deleteOrganize(item)">
                    <v-icon width="28" color="#E26269">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>ลบข้อมูล</span>
              </v-tooltip>
            </template>

            <!-- status -->
            <!-- <template v-slot:[`item.status`]="{ item }">
              <div v-if="item.status == '0'" class="d-flex flex-row">
                <span class="py-1 px-3 font-12 w-400 text-336AB4"
                  style="align-self:center ;background-color:#FFFFFF; border-radius: 99px; border: 1px solid #336AB4;">
                  รอลงทะเบียน
                </span>
              </div>
              <div v-else-if="item.status == '1'" class="d-flex flex-row">
                <span class="py-1 px-3 font-12 w-400 text-1AB759"
                  style="align-self:center ;background-color:#FFFFFF; border-radius: 99px; border: 1px solid #1AB759;">
                  ลงทะเบียนสำเร็จ
                </span>
              </div>
              <div v-else class="d-flex flex-row">
                <span class="py-1 px-3 font-12 w-400 text-FAAD14">
                  -
                </span>
              </div>
            </template> -->
          </v-data-table>
        </v-col>
      </v-row>
      <Sweetdialog ref="sweetDialog" @submit="approveDelete" />
      <RegisterDialog ref="register" @close="getOrganizeData" />
      <AddMiniApp ref="addMiniApp" @close="getOrganizeData" />
      <EditDialog ref="edit" @close="getOrganizeData" />
      <Pagination :totals="total" :isPage="page" @page="changePage" />
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Pagination } from "@/components/pagination";
import moment from "moment";
import RegisterDialog from './RegisterHospital.vue'
import AddMiniApp from './AddMiniApp.vue'
import EditDialog from './EditHospital.vue'
import Sweetdialog from '../Sweetdialog.vue'
export default {
  components: {
    Pagination,
    RegisterDialog,
    AddMiniApp,
    EditDialog,
    Sweetdialog
  },
  data() {
    return {
      chips_items: [{text: "Telemed",value: "telemed"},{text: "Telepharma",value: "telepharma"}],
      chips_value: ["telemed","telepharma"],
      select_delete: [],
      status: 0,
      page: 1,
      limit: 10,
      total: 10,
      total_organization: 10,
      total_factory: 10,
      search: '',
      headersTable: [
        {
          text: "ลำดับที่",
          value: "no",
          align: "center",
          width: "10%",
        },
        // {
        //   text: "Hospital Code",
        //   value: "hos_code",
        //   width: "10%",
        // },
        {
          text: "Business ID",
          value: "biz_id",
          width: "10%",
        },
        { 
          text: "ชื่อองค์กร", 
          value: "name", 
          width: "15%" 
        },
        { 
          text: "เบอร์โทรศัพท์ติดต่อ", 
          value: "contact", 
          width: "10%" 
        },
        { 
          text: "ที่อยู่", 
          value: "address", 
          width: "10%" 
        },
        {
          text: "บริการ",
          value: "service",
          width: "10%",
          align: "center" 
        },
        { 
          text: "Action", 
          value: "action", 
          width: "10%", 
          align: "center" 
        },
      ],
      headersTable1: [
        {
          text: "ลำดับที่",
          value: "no",
          align: "center",
          width: "10%",
        },
        // {
        //   text: "Hospital Code",
        //   value: "hos_code",
        //   width: "10%",
        // },
        {
          text: "Business ID",
          value: "biz_id",
          width: "15%",
        },
        { 
          text: "ชื่อสถานประกอบการ", 
          value: "name", 
          width: "15%" 
        },
        { 
          text: "เบอร์โทรศัพท์ติดต่อ", 
          value: "contact", 
          width: "15%" 
        },
        { 
          text: "ที่อยู่", 
          value: "address", 
          width: "10%" 
        },
        { 
          text: "Action", 
          value: "action", 
          width: "10%", 
          align: "center" 
        },
      ],
      itemTable: [],
      loadingTable: true,
      type: '',
    }
  },
  async created() {
    this.$store.dispatch("getSharedToken");
    await setTimeout(() => {
      this.loadingTable = false;
    }, 3000);
  },
  computed: {
    ...mapGetters({
      // permiss: "permissionsGetter" || {},
      path: "getPath" || "",
    }),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.type = 'organization'
    this.getOrganizeData()
  },
  methods: {
    mobile(mobile) {
      if (mobile == undefined) return "-";
      if (mobile.length == 10) {
        return (
          mobile.substring(0, 3) +
          "-" +
          mobile.substring(3, 6) +
          "-" +
          mobile.substring(6, 10)
        );
      } else if(mobile.length == 9) {
        return (
          mobile.substring(0, 1) +
          "-" +
          mobile.substring(1, 5) +
          "-" +
          mobile.substring(5, 9)
        );
      } else return mobile;
    },
    activeGet(index) {
      this.type = index;
      this.page = 1;
      this.getOrganizeData();
    },
    approveDelete() {
      try {
        var params = new URLSearchParams();
        params.append('biz_id', this.select_delete.biz_id)

        this.axios.delete(process.env.VUE_APP_BACKEND_URL+`/v1/organization/delete_organization?${params}`)
        .then((res) => {
          if(res.data.result == 'success') {
            this.$swal({
              title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ลบข้อมูลสำเร็จ</span>",
              icon: "success",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#00A99D",
            }).then(() => {
              this.deleteBizOnePlatform(this.select_delete.biz_id)
            })
          } else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ลบข้อมูลไม่สำเร็จ</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
            this.getOrganizeData()
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    deleteBizOnePlatform(biz) {
      try {
          const params = new URLSearchParams();
          params.append("business_id", biz);

          this.axios.post(process.env.VUE_APP_BACKEND_URL+`/v1/delete/biz/platform?${params}`).then((res) => {
            if (res.data.result == "success" && res.data.code == 200) {
              this.getOrganizeData()
            } else {
              this.getOrganizeData()
            }
        })
      } catch(err) {
        console.log(err);
      }
    },
    deleteOrganize(item) {
      this.select_delete = item
      const data = {
        title: "<span style='color: black;font-size: 24px;font-family: Sarabun;font-weight: 500;'><b>ท่านยืนยันลบข้อมูลนี้ใช่หรือไม่ ?</b></span>",
        html: "<span style='color: black;font-size: 16px;font-family: Sarabun;font-weight: 500;'>"+ item.first_name_th +"</span>",
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
        cancelButtonColor: "#FFFFFF",
        showConfirmButton: true,
        confirmButtonText: "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        allowOutsideClick: false,
        returnEmit: 'confirm',
      }
      this.$refs.sweetDialog.open(data)
    },
    editOrganize(item) {
      this.$refs.edit.openDialog(item)
    },
    registerOrganize() {
      this.$refs.register.openDialog()
    },
    addMiniApp() {
      this.$refs.addMiniApp.openDialog()
    },
    changePage(page) {
      this.page = page;
      this.getOrganizeData()
    },
    showDate(item) {
      var year1 = ""
      var year2 = ""
      year1 = moment(item).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(item).locale("th").format("DD/MM/" + year2)
    },
    showTime(item) {
      return moment(item).locale("TH").format("LT");
    },
    getOrganizeData() {
      this.loadingTable = true
      this.itemTable= []
      try {
        var body = []
        if(this.chips_value == [] || this.chips_value.length == 0) {
          body = ['ไม่มีบริการ']
        } else {
          body = this.chips_value
        }

        var params = new URLSearchParams();
        params.append('keyword', this.search)
        params.append('limit', this.limit)
        params.append('page', this.page)
        params.append('type', this.type)

        this.axios.post(process.env.VUE_APP_BACKEND_URL + `/v1/organization/getOrganization?${params}`,
          {
            service: body
          }
        ).then((res) => {
          if (res.data.result == 'success') {
             setTimeout(() => {
               this.loadingTable = false
                this.total = res.data.data.pagination.total
                this.total_factory = res.data.data.pagination.total_factory
                this.total_organization = res.data.data.pagination.total_organization
                this.page = res.data.data.pagination.page
                this.itemTable = res.data.data.data
              }, 1500);   
          }
        })
      } catch (err) {
        this.loadingTable = false;
        console.log(err);
      } 
    }
  }
}
</script>

<style scoped>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #fbfffe;
  border-radius: 80px 0px 0px 0px;
}
.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-small3 {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-small2 {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}
.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}
.theme-back-text {
  color: #ffffff;
  font-size: 18px;
  padding-left: 0px;
}
.theme-light-text {
  color: #00a99d;
  font-size: 18px;
  padding-left: 0px;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}
::v-deep .v-image__image--cover {
  background-size: auto;
}
::v-deep .v-responsive {
  flex: none !important;
}
::v-deep .v-data-table-header {
  background: #ceefed;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 14px !important;
  height: 48px;
}
::v-deep .v-select__selections {
  line-height: 25px;
}
::v-deep .image-border.v-btn:not(.v-btn--round).v-size--small {
  height: 28px;
  min-width: 38px !important;
  max-width: 38px !important;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}
::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}
::v-deep .v-data-table-header__icon {
  display: none;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}
::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}
::v-deep .v-data-table-header__icon {
  display: none;
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){
  background: #ceefed !important;
}
::v-deep .image-border.v-btn:not(.v-btn--round).v-size--small {
  height: 28px;
  min-width: 38px !important;
  max-width: 38px !important;
}
</style>